import React from "react";
import { Tab, TabList, Tabs } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";

const DEFAULT_ITEMS = [
  { label: "Templates", to: "/performance/pms-format/templates" },
  { label: "Rating scales", to: "/performance/pms-format/rating-scales" },
  { label: "Imports", to: "/performance/pms-format/imports" },
];

const PerformanceLocalNav = ({ items = DEFAULT_ITEMS }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeIndex = Math.max(
    0,
    items.findIndex((item) => location.pathname.startsWith(item.to)),
  );

  return (
    <Tabs
      index={activeIndex}
      onChange={(index) => navigate(items[index].to)}
      variant="line"
      colorScheme="blue"
      size="sm"
    >
      <TabList overflowX="auto" overflowY="hidden">
        {items.map((item) => (
          <Tab key={item.to} whiteSpace="nowrap">
            {item.label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

export default PerformanceLocalNav;
